import { usePopoverStore } from '@widgets/messenger/stores/usePopoverStore'
import type { PopoverName, Popovers } from '@widgets/messenger/types/popover'
import { useWidgetBroadcastEvents } from '@widgets/messenger/compositions/useWidgetBroadcastEvents'

export const useWidgetPopovers = () => {
  const popoverStore = usePopoverStore()
  const { emitPopoverClosed, onPopoverClosed, removeSubscription } = useWidgetBroadcastEvents()

  const openPopover = <T extends PopoverName>(name: T, payloadGetter: () => Popovers[T]) => {
    popoverStore.setOpenedPopover({ name, payloadGetter })
  }

  const closePopover = <T extends PopoverName>(name: T, doNotEmitEvent?: boolean) => {
    if (name && popoverStore.openedPopover.value?.name !== name) return
    popoverStore.setOpenedPopover(null)
    if (doNotEmitEvent) return
    emitPopoverClosed(name)
  }

  const subscribeOnPopoverClosed = () => {
    return onPopoverClosed((name) => {
      closePopover(name, true)
    })
  }

  const unsubscribeFromPopoverClosed = (subscriptionId: string) => {
    removeSubscription(subscriptionId)
  }

  return {
    openedPopover: popoverStore.openedPopover,
    openPopover,
    closePopover,
    subscribeOnPopoverClosed,
    unsubscribeFromPopoverClosed,
  }
}
